var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScannCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    "data-name": "auditor-audit-magnifying glass-handsearch"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.554 30.216a13 13 0 1 0-7.336-6.722 13.007 13.007 0 0 0 7.336 6.722zm-5.891-15.979a11 11 0 1 1 6.574 14.1 11.019 11.019 0 0 1-6.574-14.1z",
    fill: "#bd7201",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 35a17.033 17.033 0 1 0-10.91-3.98l-3.13-.54a17.415 17.415 0 0 0-9.57.99 15.576 15.576 0 0 1-8.47.9l-.28-.05-.35 1.96.28.05a17.016 17.016 0 0 0 3.04.27 17.3 17.3 0 0 0 6.53-1.27 15.379 15.379 0 0 1 8.48-.88l4.22.73a5.516 5.516 0 0 1 1.52.54l-.36.99a1 1 0 0 0-1.28.6l-.65 1.8-3.87-.68-.35 1.97L40.63 41a2.013 2.013 0 0 1 1.29.83 2.056 2.056 0 0 1 .31 1.58 1.912 1.912 0 0 1-2.21 1.55l-12.89-2.27-.35 1.97 12.8 2.25a3.009 3.009 0 0 1-1.92 2.3 3.043 3.043 0 0 1-1.55.14l-9.85-1.74-.35 1.97 9.85 1.74a4.909 4.909 0 0 0 .86.07c.05 0 .1-.01.14-.01l-.01.11a3.009 3.009 0 0 1-1.93 2.29 2.938 2.938 0 0 1-1.55.14l-8.86-1.56-.35 1.97 8.86 1.56a5 5 0 0 0 .86.08.772.772 0 0 0 .15-.02l-.02.12a3.017 3.017 0 0 1-3.48 2.43l-8.26-1.46a36.4 36.4 0 0 1-8.55-2.61 30.429 30.429 0 0 0-7.1-2.18l-1.35-.23-.34 1.96 1.35.24a28.522 28.522 0 0 1 6.62 2.03 38.525 38.525 0 0 0 9.02 2.76l.25.05-.25.68a.993.993 0 0 0 .6 1.28l5.64 2.05a1.016 1.016 0 0 0 .34.06 1 1 0 0 0 .94-.66l.73-2h.01a5.332 5.332 0 0 0 .88.08 5.016 5.016 0 0 0 4.92-4.14l.17-.99a4.98 4.98 0 0 0 2.66-3.58l.18-1a4.98 4.98 0 0 0 2.66-3.58l.09-.5a3.693 3.693 0 0 0 .95-.48 3.887 3.887 0 0 0 1.62-2.6 3.975 3.975 0 0 0-3.23-4.64l-2.92-.52.17-.48a1 1 0 0 0-.03-.76 1.037 1.037 0 0 0-.57-.52l.73-1.99A16.4 16.4 0 0 0 41 35zM27.8 60.85l-3.76-1.37.03-.07 4 .7zm4.27-23.39.19-.53 3 1.1zm3.68-1.38-1.87-.69.61-1.69c.62.25 1.25.46 1.9.65zM26 18a15 15 0 1 1 15 15 15.018 15.018 0 0 1-15-15z",
    fill: "#bd7201",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScannCheck);
export default __webpack_public_path__ + "static/media/scann-check.a9cee498ac727be262fb65e0f5c147e0.svg";
export { ForwardRef as ReactComponent };